/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
const STATUS_TIMELINE_CONSTANTS = {
    colors: {
        predictionPath: {
            backgroundColor: '#ffffff',
            borderColor: '#d9d9d9',
        },
        fixedPath: {
            backgroundColor: '#ffffff',
            borderColor: '#444444'
        }
    }
};

export default STATUS_TIMELINE_CONSTANTS;
